import React from "react";
import { useNavigate } from "react-router-dom";
import StripeProductTable from "./StripeProductsTable";

const Stripe = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="flex items-center justify-between">
        <p className="font-semibold antialiased tracking-wide text-[22px]">
          Stripe Products
        </p>

        <button
          onClick={() => navigate("/stripe/new")}
          className="bg-[#4186F6] h-10 w-[240px] text-white rounded-[8px]"
        >
          <p>Create New Stripe Product</p>
        </button>
      </div>

      <div className="mt-10">
        <StripeProductTable />
      </div>
    </div>
  );
};

export default Stripe;
